import React from 'react';
import Styles from './styles.js';

const NewHeadingSection = ({ title }) => {
  return (
    <>
      <div className="">
        <h2 className="BUS-head-title text-xl lg:text-2xl border-b-2 pb-3 mb-10  ">{title.toUpperCase()}</h2>
      </div>
      <Styles />
    </>
  );
};

export default NewHeadingSection;
